import Timetable from "./Timetable";

export default Timetable;
